import {
  InteractionContainerName,
  InteractionEvent,
  InteractionGoal,
  trackEvent,
} from '@/helpers/GTM/GTMHelper';

export function trackNoteAdd(): void {
  trackEvent(InteractionEvent.GENERIC_INTERACTION, {
    h_event_category_006: InteractionEvent.GENERIC_INTERACTION,
    h_event_action_007: InteractionGoal.ADD_NOTE,
    h_event_label_008: undefined,
  });
}

export function trackNoteRemove(): void {
  trackEvent(InteractionEvent.GENERIC_INTERACTION, {
    h_event_category_006: InteractionEvent.GENERIC_INTERACTION,
    h_event_action_007: InteractionGoal.DELETE_NOTE,
    h_event_label_008: undefined,
  });
}

export function trackNoteEdit(): void {
  trackEvent(InteractionEvent.GENERIC_INTERACTION, {
    h_event_category_006: InteractionEvent.GENERIC_INTERACTION,
    h_event_action_007: InteractionGoal.EDIT_NOTE,
    h_event_label_008: undefined,
  });
}

export function trackNoteSave(action: string): void {
  trackEvent(InteractionEvent.GENERIC_INTERACTION, {
    h_event_category_006: InteractionEvent.GENERIC_INTERACTION,
    h_event_action_007: InteractionGoal.SAVE_NOTE,
    h_event_label_008: action,
  });
}

export function trackNoteDeleteTrial(): void {
  trackEvent(InteractionEvent.GENERIC_INTERACTION, {
    h_event_category_006: InteractionEvent.GENERIC_INTERACTION,
    h_event_action_007: InteractionGoal.DELETE_NOTE_TRIAL,
    h_event_label_008: undefined,
  });
}

export function trackContactClick(params: { listingId: string; listingPosition: number }): void {
  trackEvent(InteractionEvent.FAVOURITES_INTERACTION, {
    h_event_category_006: InteractionContainerName.FAVOURITES_CLICKTHROUGH,
    h_event_action_007: InteractionGoal.GO_TO_PDP,
    h_event_label_008: params.listingId,
    h_listing_advertisement_id_120: params.listingId,
    h_position_on_list_overall_283: params.listingPosition,
    h_extra_information_144: InteractionGoal.OPEN_FORM_LEAD,
  });
}
